import { useMemo } from 'react'

import type { ListShipment } from '@fv/client-types'

import { useAccountSettings } from '../settings/account-settings/hooks'
import { computeBatchPrintSummary } from './batchPrintEligibility'

export function useBatchPrintEligibility(loads: ListShipment[]) {
  const settings = useAccountSettings()

  return useMemo(
    () => computeBatchPrintSummary(loads, settings.shipping),
    [loads, settings.shipping],
  )
}
